import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.WorkflowSettingsPopupContent.SectionNetSuiteCustomFormId', {
    title: 'NetSuite Custom Form Id',
    subtitle:
        'By default, ApprovalMax creates and updates NetSuite transactions using NetSuite preferred form. You can select a specific NetSuite custom form id that should be used for this organization.',
    placeholder: 'Enter NetSuite form id',
});
